<template lang="pug">
.bloco-data-acao-monitoramento-agricola
    .bloco-data-acao-monitoramento-agricola__interno
        span
            slot(name='icone')
                i.mdi.mdi-satellite
        span.bloco-data-acao-monitoramento-agricola__interno-texto {{ titulo }}
    span.bloco-data-acao-monitoramento-agricola__interno-numero {{ valor }}
</template>

<script>
export default {
    name: 'BlocoDataAcaoMonitoramentoAgricola',
    props: {
        titulo: {
            type: String,
            default: () => ''
        },
        valor: {
            type: String,
            default: () => ''
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.bloco-data-acao-monitoramento-agricola {
    min-width: 32%;
    background: var(--white);
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
    min-height: 89px;
    align-items: center;
    color: var(--primary);
    flex-wrap: wrap;
    box-shadow: 0px 0px 2px 0px var(--block-shadow);
    padding: 20px 20px;
    .bloco-data-acao-monitoramento-agricola__interno {
        margin-right: 3px;
        display: flex;
        justify-content: center;
        align-items: center;
        .mdi::before {
            font-size: 30px !important;
            color: var(--primary) !important;
        }
    }
    .bloco-data-acao-monitoramento-agricola__interno-numero {
        flex-wrap: wrap;
        font-size: 20px;
    }
    span {
        padding: 3px;
        &.bloco-data-acao-monitoramento-agricola__interno-texto {
            font-weight: 500;
        }
    }

    &:first-child {
        margin: 2px 3px 2px 0px;
    }

    &:not(:first-child) {
        margin: 2px 3px 2px 2px;
    }
}
</style>
